import React, { useContext, useEffect, useState } from "react";
import Dropdown from "../../Genericos/Dropdown/Dropdown";
import DatePicker from "../../Genericos/DatePicker/DatePicker";
import { PortalContext } from "../../../context/Provider";
import {
  wsGetVerificaEstudiosQr,
  wsPostTurnosEstudiosQr,
  logoutEstudiosTurnos,
  wsPostCalulaMinutos,
  wsPostTurnosKinesioQr,
} from "../../../context/Actions/turnos/estudioTurnos";
import fechaTurnoFormat from "../../../../global/utils/fechaTurnoFormat";
import { showToaster } from "../../../../global/context/action/toaster/toaster";
import { useHistory } from "react-router";
import { showModal, hideModal } from "../../../context/Actions/modal/modal";
import {
  editaTurnosDisponibles,
  resetFiltrosDisponibles,
  setFechaTurno,
} from "../../../context/Actions/turnos/turnosDisponibles";

import TurnosAgregados from "../TurnosAgregados/TurnosAgregados";
import InformacionBuscador from "../../Genericos/InformacionBuscador/InformacionBuscador";
import { IonSpinner } from "@ionic/react";
import "./BuscadorEstudio.css";
import { dropdownFamiliares } from "../ListaFamiliaresDropdown/ListaFamiliaresDropdown";
import { GlobalContext } from "../../../../global/context/Provider";
// import PresentismoBox from "../PresentismoBox/PresentismoBox";
// import {
//   resetPresentismo,
//   wsGetPresentismoDetalle,
// } from "_+_Portal/context/Actions/presentismo/presentismo";
import DropdownV2 from "_+_Portal/components/Genericos/DropdownV2/DropdownV2";
import { resetOrdenDigitalEstudio } from "_+_Portal/context/Actions/ordenDigital/ordenDigital";
import { wsGetDatosBioseguridad } from "_+_Portal/context/Actions/paciente/paciente";

const BuscadorEstudio = ({
  listaDeterminaciones,
  onChangeMultitabMobile,
  buscadorTurnos,
}) => {
  const history = useHistory();
  const {
    estudioGrupoState,
    estudioTurnosDispatch,
    estudioTurnosState,
    modalDispatch,
    turnosDisponiblesDispatch,
    turnosDisponiblesState,
    listaFamiliaresState,
    selectDropDownState,
    textosState,
    // presentismoDispatch,
    presentismoState,
    ordenDigitalState,
    ordenDigitalDispatch,
    pacienteDispatch,
  } = useContext(PortalContext);

  // Cambio de contexto
  const { authState, toasterDispatch, configState } = useContext(GlobalContext);

  const hoy = new Date();
  const fechaLimte = new Date();
  const days = 90;
  fechaLimte.setDate(fechaLimte.getDate() + days);
  let accion = sessionStorage.getItem("accionHash");

  // no existen las VC en "ESTUDIOS" habria que sacar este useState y reemplazarlo por un false.
  const [onChangeVc, setOnChangeVc] = useState(false);
  const [idEstudio, setIdEstudio] = useState("");
  const [descEstudio, setDescEstudio] = useState("");
  const [leyendaCircuito, setLeyendaCircuito] = useState("");
  const [gruposMedico, setGruposMedico] = useState([]);
  const [fechaDeHoy, setFechaDeHoy] = useState();
  const [onChangeDate, setOnChangeDate] = useState(null);
  const [preguntasReso, setPreguntasReso] = useState();
  const [preguntasTomo, setPreguntasTomo] = useState();
  const [flgParticular, setFlgParticular] = useState(false);
  const [flgBusquedaDefault, setFlgBusquedaDefault] = useState(false);
  const [determinaciones, setDeterminaciones] = useState(listaDeterminaciones);
  const [flgModal, setFlgModal] = useState(false);
  const [flgPrepaKin, setPrepaKin] = useState(false);
  const [dtoPOST, setDtoPOST] = useState(false);
  const [user, setUser] = useState(authState);
  const [errorDropdown, setErrorDropdown] = useState(false);
  const [flgDobleVerif, setFlgDobleVerif] = useState(false);
  const [OSAlternativa, setOSAlternativa] = useState(false);

  const [dtoBusqEstudioDefault, setDtoBusqEstudioDefault] = useState({
    amamantando: false,
    conContraste: false, ////lo obtengo de seleccionar el item especialidad o estudio
    contrasteReciente: false,
    diabeticoHipertenso: false,
    embarazada: false,
    fechaDesde: fechaDeHoy, //fecha esta en datepicker
    GruposMedico: [
      {
        Id: idEstudio,
        Descripcion: descEstudio,
        Particular: flgParticular,
      },
    ],
    idGrupoMedico: idEstudio, //lo obtengo de seleccionar el item especialidad o estudio
    idObraSocial: user.auth.data.paciente.obra_social,
    idPlan: user.auth.data.paciente.idplan,
    insRenal: false,
    marcapasos: false,
    operador: accion ? "BOT" : "",
    pag: 1200, //hardcodeado en angular
    particular: flgParticular,
    peso: false,
    rec: 0, //harcodeado en angularionic
    videoAtencion: onChangeVc, //lo lleno por con el checkbox
  });
  const [dtoBusqEstudioCReso, setDtoBusqEstudioCReso] = useState();
  const [dtoBusqEstudioCTomo, setDtoBusqEstudioCTomo] = useState();
  const [dtoBusqEstudioCircuito, setDtoBusqEstudioCircuito] = useState();
  const [dtoCalculaMinutos, setDtoCalculaMinutos] = useState();
  const [flgTurnosKin, setFlgTurnosKin] = useState(false);
  const [flgCalculaMins, setFlgCalculaMins] = useState(false);
  const [activarBusqueda, setActivarBusqueda] = useState(false);
  const [flgOrden, setFlgOrden] = useState(false);
  const [ordenesDigitales, setOrdenesDigitales] = useState([]);
  const [ordenesAgregadas, setOrdenesAgregadas] = useState([]);

  let config = localStorage.getItem("config");
  let bloqueoPresentismo = JSON.parse(config).opcBloqueoPresentismo;

  // crear un useEffect para poder setear el user
  useEffect(() => {
    if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      // es el paciente completo
      setUser({
        auth: {
          data: selectDropDownState.selectDropDown.selectGlobal.pacienteElegido,
        },
      });
    } else {
      setUser(authState);
    }
  }, [selectDropDownState.selectDropDown.selectGlobal.pacienteElegido]);

  const dissmiss = () => {
    hideModal()(modalDispatch);
    if (estudioTurnosState.estudioTurnos.data) {
      if (
        estudioTurnosState.estudioTurnos.data.continua &&
        estudioTurnosState.estudioTurnos.data.circuito === "KIN"
      ) {
        setPrepaKin(true);
      }
    }
    // resetPresentismo()(presentismoDispatch);
  };

  const volverAOrdenes = () => {
    resetOrdenDigitalEstudio()(ordenDigitalDispatch);
    history.push("/autocheckin");
  };

  const dissmissPreparacion = () => {
    hideModal()(modalDispatch);
    if (estudioTurnosState.estudioTurnos.data) {
      if (
        estudioTurnosState.estudioTurnos.data.continua &&
        estudioTurnosState.estudioTurnos.data.circuito === "KIN"
      ) {
        setPrepaKin(true);
      } else {
        // borro la data en el dissmiss de la preparacion ya que,
        // si vuelvo a buscar kinesio, no levanta el modal de part.
        logoutEstudiosTurnos()(estudioTurnosDispatch);
        if (ordenDigitalState.ordenDigital.altaTurno !== null) {
          setFlgOrden(true);
        }
      }
    }
  };

  useEffect(() => {
    // Tengo que hacerlo en un useEffect porque de lo contrario
    // no realiza la busqueda.
    if (flgOrden) {
      if (ordenesDigitales.length > 1) {
        if (ordenesDigitales.length === ordenesAgregadas.length) {
          onBuscarTurnosClick();
        } else {
          setFlgOrden(false);
          // Revisar, capaz poner un index en lugar de ordenesAgregadas.length
          onChangeBuscador(ordenesDigitales[ordenesAgregadas.length]);
        }
      } else {
        onBuscarTurnosClick();
      }
    }
  }, [flgOrden]);

  const onChangeDatePicker = (e) => {
    setOnChangeDate(e);
    setFechaTurno(e)(turnosDisponiblesDispatch);
  };

  const onChangeBuscador = (e) => {
    setOSAlternativa(false);
    if (e !== "") {
      if (
        (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
          ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
              .paciente.ausentismo.rankingPracticas === "Rojo"
          : authState.auth.data.paciente.ausentismo.rankingPracticas ===
            "Rojo") &&
        (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
          ? !selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
              .paciente.seguimiento
          : !authState.auth.data.paciente.seguimiento) &&
        bloqueoPresentismo === true
      ) {
        showModal(
          "Genericos/Mensaje/Mensaje",
          {
            titulo: <p className="rb24b">Atención</p>,
            textoNegrita: (
              <p className="rb18l">
                {textosState?.textos?.data?.msjBloqueoAusentismo?.descripcion}
              </p>
            ),
            dissmiss: dissmiss,
          },
          [
            {
              text: "Cerrar",
              clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
              accion: dissmiss,
            },
          ],
          "centro",
          true
        )(modalDispatch);
      } else {
        let arrxOrdenes = ordenesAgregadas ? [...ordenesAgregadas] : [];
        arrxOrdenes.push(e);
        setOrdenesAgregadas(arrxOrdenes);
        setIdEstudio(e.id);
        setDescEstudio(e.descripcion);
        setFlgParticular(false);
        setFlgModal(false);
        //me agrego la leyenda desde un principio, para los casos en que voy a part.
        setLeyendaCircuito(e.idcircuito);
        if (e.id !== null && e.id !== undefined) {
          // setDeshabilitoBusq(false);
          if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
            wsGetVerificaEstudiosQr(
              e.id,
              false,
              false,
              false
            )(estudioTurnosDispatch);
          } else {
            wsGetVerificaEstudiosQr(
              e.id,
              false,
              false,
              false
            )(estudioTurnosDispatch);
          }
        }
      }
    } else if (e === "" && gruposMedico.length >= 1) {
      // setDeshabilitoBusq(false);
    } else {
      setIdEstudio("");
      setDescEstudio("");
      // setDeshabilitoBusq(true);
    }
  };

  const onBuscarTurnosClick = () => {
    if (leyendaCircuito === "KIN") {
      if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
        wsGetVerificaEstudiosQr(idEstudio, false, false)(estudioTurnosDispatch);
      } else {
        wsGetVerificaEstudiosQr(idEstudio, false, false)(estudioTurnosDispatch);
      }
    } else {
      if (
        (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
          ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
              .paciente.ausentismo.rankingPracticas === "Rojo"
          : authState.auth.data.paciente.ausentismo.rankingPracticas ===
            "Rojo") &&
        (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
          ? !selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
              .paciente.seguimiento
          : !authState.auth.data.paciente.seguimiento) &&
        bloqueoPresentismo === true
      ) {
        showModal(
          "Genericos/Mensaje/Mensaje",
          {
            titulo: <p className="rb24b">Atención</p>,
            textoNegrita: (
              <p className="rb18l">
                {textosState?.textos?.data?.msjBloqueoAusentismo?.descripcion}
              </p>
            ),
            dissmiss: dissmiss,
          },
          [
            {
              text: "Cerrar",
              clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
              accion: dissmiss,
            },
          ],
          "centro",
          true
        )(modalDispatch);
      } else {
        if (idEstudio !== "") {
          if (!flgModal) {
            if (
              idEstudio !== "" &&
              Array.isArray(gruposMedico) &&
              !flgParticular &&
              gruposMedico.length > 0
            ) {
              // esta seria la que usamos ahora si el circuito es rmn o tomo
              if (leyendaCircuito !== "TOMO" && leyendaCircuito !== "RMN") {
                setActivarBusqueda(true);
              } else {
                modalDatosNecesarios();
              }
            } else if (idEstudio !== "" && flgBusquedaDefault) {
              //devuelve el dto de busquedadefault con la ultima fecha seleccionada
              let objBusqueda = verificaCambioFecha();
              objBusqueda = verificaOSAlternativa(objBusqueda);
              setDtoPOST(objBusqueda);
              wsPostTurnosEstudiosQr(objBusqueda)(estudioTurnosDispatch);
              setFlgBusquedaDefault(false);
            } else {
              showToaster(
                {
                  texto: "Vuelva a comenzar la búsqueda",
                  tipo: "danger",
                },
                "centroArriba"
              )(toasterDispatch);
              setErrorDropdown(true);
            }
          } else {
            if (
              selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
            ) {
              wsGetVerificaEstudiosQr(
                idEstudio,
                false,
                false
              )(estudioTurnosDispatch);
            } else {
              wsGetVerificaEstudiosQr(
                idEstudio,
                false,
                false
              )(estudioTurnosDispatch);
            }
          }
        } else {
          setErrorDropdown(true);
        }
      }
    }
  };

  const verificaCambioFecha = () => {
    let objBusqDefault = Object.assign({}, dtoBusqEstudioDefault);
    if (onChangeDate !== null) {
      objBusqDefault.fechaDesde = onChangeDate;
    } else if (
      turnosDisponiblesState.turnosDisponibles.turnosData.fechaSeleccionada
    ) {
      objBusqDefault.fechaDesde =
        turnosDisponiblesState.turnosDisponibles.turnosData.fechaSeleccionada;
    }
    return objBusqDefault;
  };

  const verificaOSAlternativa = (objBusqueda) => {
    if (OSAlternativa) {
      objBusqueda.OsAlternativa = true;
    } else {
      objBusqueda.OsAlternativa = false;
    }
    return objBusqueda;
  };

  const cancelaParticular = () => {
    dissmiss();
    logoutEstudiosTurnos()(estudioTurnosDispatch);
    setFlgParticular(false);
    setFlgCalculaMins(false);
  };

  const cancelaAlternativa = () => {
    dissmiss();
    logoutEstudiosTurnos()(estudioTurnosDispatch);
    setOSAlternativa(false);
  };

  const deterComoParticular = (origen) => {
    if (origen === "osAlternativa") {
      setOSAlternativa(true);
    }
    dissmiss();
    setFlgModal(false);
    if (leyendaCircuito !== "" && leyendaCircuito !== "KIN") {
      setFlgParticular(false);
      const arrDeter = determinaciones.filter(
        (item) =>
          item.idcircuito === estudioTurnosState.estudioTurnos.data.circuito
      );
      setDeterminaciones(arrDeter);
      const arrGrupoMed = gruposMedico.filter((item) => item.id === idEstudio);
      if (typeof arrGrupoMed !== "undefined" && arrGrupoMed.length > 0) {
        showToaster(
          {
            texto: "Ya existe el turno agregado!",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
        logoutEstudiosTurnos()(estudioTurnosDispatch);
      } else {
        setGruposMedico([
          ...gruposMedico,
          {
            id: idEstudio,
            descripcion: descEstudio,
            /*diasbusqueda: 0,
            filtroedadmax: 0,
            filtroedadmin: 0,
            idequivcontraste: 0,
            incidenciasmin: 0,
            omitirporminbusq: 0,
            videoatencion: false,*/
            particular: true,
          },
        ]);
        logoutEstudiosTurnos()(estudioTurnosDispatch);
        if (ordenDigitalState.ordenDigital.altaTurno !== null) {
          setFlgOrden(true);
        }
      }
    } else {
      logoutEstudiosTurnos()(estudioTurnosDispatch);
      setFlgDobleVerif(true);
    }
  };

  useEffect(() => {
    if (flgDobleVerif) {
      setFlgDobleVerif(false);
      if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
        //si es acepte que sea particular vuelvo a verificar, pero esta vez como particular.
        wsGetVerificaEstudiosQr(
          idEstudio,
          true,
          false,
          OSAlternativa ? OSAlternativa : false
        )(estudioTurnosDispatch);
      } else {
        wsGetVerificaEstudiosQr(
          idEstudio,
          true,
          false,
          OSAlternativa ? OSAlternativa : false
        )(estudioTurnosDispatch);
      }
    }
  }, [flgDobleVerif]);

  const modalDatosNecesarios = () => {
    wsGetDatosBioseguridad((isCorrect, data) => {
      if (isCorrect) {
        if (leyendaCircuito === "RMN") {
          showModal(
            "Genericos/Preguntas/CircuitoReso2",
            {
              titulo: "Datos necesarios",
              texto:
                "Porfavor, complete los siguientes datos para buscarle turnos",
              dissmiss:
                ordenDigitalState.ordenDigital.altaTurno !== null
                  ? () => {
                      dissmiss();
                      volverAOrdenes();
                    }
                  : () => dissmiss(),
              dataBioseguridad: data,
            },
            [],
            "centro",
            true
          )(modalDispatch);
        } else {
          showModal(
            "Genericos/Preguntas/CircuitoTomo2",
            {
              titulo: "Datos necesarios",
              texto:
                "Porfavor, complete los siguientes datos para buscarle turnos",
              dissmiss:
                ordenDigitalState.ordenDigital.altaTurno !== null
                  ? () => {
                      dissmiss();
                      volverAOrdenes();
                    }
                  : () => dissmiss(),
              dataBioseguridad: data,
            },
            "centro"
          )(modalDispatch);
        }
      } else {
        showModal(
          "Genericos/Mensaje/Mensaje",
          {
            titulo: "Atención",
            textoNegrita: (
              <span className="rb18l">
                {data.data
                  ? data.data
                  : "Error al obtener datos de bioseguridad del paciente"}
              </span>
            ),
            dissmiss: dissmiss,
            danger: true,
          },
          [
            {
              text: "Cerrar",
              clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
              accion: dissmiss,
            },
          ],
          "centro",
          true
        )(modalDispatch);
      }
    })(pacienteDispatch);
  };

  const showInfoBuscador = () => {
    // alert("Puede seguir buscando mas turnos del mismo tipo");
  };

  const modalParticular = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "La obra social no cubre el estudio",
        textoNegrita: "¿Desea tomar el turno como particular?",
        texto:
          estudioTurnosState.estudioTurnos.data?.mensaje !== ""
            ? estudioTurnosState.estudioTurnos.data.mensaje
            : "El estudio seleccionado no figura dentro de tu cobertura",
        dissmiss:
          ordenDigitalState.ordenDigital.altaTurno !== null
            ? () => {
                dissmiss();
                volverAOrdenes();
              }
            : dissmiss,
      },
      [
        {
          text: "Cancelar",
          clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
          accion:
            ordenDigitalState.ordenDigital.altaTurno !== null
              ? () => {
                  cancelaParticular();
                  volverAOrdenes();
                }
              : cancelaParticular,
        },
        {
          text: "Tomar como particular",
          clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
          accion: deterComoParticular,
        },
      ],
      "centro"
    )(modalDispatch);
  };

  const modalOSAlternativa = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "La obra social no cubre el estudio",
        textoNegrita: "¿Deseás tomar el turno con tu obra social alternativa?",
        texto:
          estudioTurnosState.estudioTurnos.data?.mensaje !== ""
            ? estudioTurnosState.estudioTurnos.data.mensaje
            : "El estudio seleccionado no figura dentro de tu cobertura",
        dissmiss: dissmiss,
      },
      [
        {
          text: "Cancelar",
          clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
          accion: cancelaAlternativa,
        },
        {
          text: "Tomar con OS alternativa",
          clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
          accion: () => deterComoParticular("osAlternativa"),
        },
      ],
      "centro"
    )(modalDispatch);
  };

  const modalAtencionSinTurnoPrevio = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "El estudio se realiza sin turno previo",
        textoNegrita: "Prueba",
        texto: "a Definir",
        dissmiss: dissmiss,
        danger: true,
      },
      [
        {
          text: "Salir",
          clase: "btn-Mensaje-1 rb16m bgc-latex10 c-white",
          accion: dissmiss,
        },
        {
          text: "Leer sobre turnos sin reserva",
          clase: "btn-Mensaje-1 rb16m bgc-latex30 c-white",
          accion: dissmiss,
        },
      ],
      "centro"
    )(modalDispatch);
  };

  const onClickHandlerCancelarEtiq = (e) => {
    const arr = gruposMedico.filter((item) => item.id !== e);
    setGruposMedico(arr);
    //vuelvo a setear la lista del dropdown original ya que sali del circuito.
    if (arr.length === 0) {
      const arrGrupoMed = estudioGrupoState.estudioGrupo.data.filter(
        (item) => item.sonpracticas === true && item.id > 0
      );
      setDeterminaciones(arrGrupoMed);
      setLeyendaCircuito("");
      setIdEstudio("");
      setDescEstudio("");
      // setDeshabilitoBusq(true);
    }
  };

  //funciones y logica Kinesio
  const showModalKinesio = () => {
    //saco el domingo ya que no entra dentro de los dias.
    turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.diasKin.pop();
    showModal(
      "Turnos/FiltrosKinesio/FiltrosKinesio",
      {
        titulo: "Filtrar por dia y hora",
        dissmiss: dissmissKinesio,
        onChangeDatePicker: onChangeDatePicker,
        onHandleBuscarTurnosKin: onHandleBuscarTurnosKin,
        fecha: hoy,
      },
      [],
      "centro",
      true
    )(modalDispatch);
  };

  const dissmissKinesio = () => {
    resetFiltrosDisponibles()(turnosDisponiblesDispatch);
    hideModal()(modalDispatch);
    setPrepaKin(false);
  };

  const onHandleBuscarTurnosKin = (dias, rango) => {
    editaTurnosDisponibles({
      ...turnosDisponiblesState.turnosDisponibles.turnosData,
      filtrosData: {
        ...turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData,
        diasKin: dias,
        rangoKinesio: rango,
      },
    })(turnosDisponiblesDispatch);
    setFlgTurnosKin(true);
  };

  useEffect(() => {
    if (flgTurnosKin) {
      let auxDias =
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.diasKin.filter(
          (item) => item.checked !== false && item.id !== 0
        );
      let auxKin =
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.rangoKinesio.filter(
          (item) => item.checked !== false && item.id !== 0
        );

      // // Filtrado provisorio de días
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
          .diasKin[0]?.checked
      ) {
        auxDias =
          turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.diasKin.filter(
            (item) => item.id !== 0
          );
      }

      // // Filtrado provisorio de rangoKinesio
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
          .rangoKinesio[0]?.checked
      ) {
        auxKin =
          turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.rangoKinesio.filter(
            (item) => item.id !== 0
          );
      }

      if (auxDias.length >= 3 && auxKin.length > 0) {
        auxDias = auxDias.map((array) => array.id);
        auxKin = auxKin.map((array) => array.rango);
        let config = localStorage.getItem("config");
        let sectorTurno = JSON.parse(config).sectorTurno;

        let dtoKin = {
          cantidad: 10,
          fechaDesde: onChangeDate !== null ? onChangeDate : fechaDeHoy,
          idGrupoMedico: idEstudio,
          listDias: auxDias,
          listHorario: auxKin,
          particular: flgParticular,
          sectorTurno: sectorTurno,
        };
        setFlgTurnosKin(false);
        hideModal()(modalDispatch);
        wsPostTurnosKinesioQr(dtoKin)(estudioTurnosDispatch);
      } else {
        setFlgTurnosKin(false);
        showToaster(
          {
            texto: "Seleccione al menos 1 rango horario y 3 dias de la lista",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      }
    }
  }, [flgTurnosKin]);

  useEffect(() => {
    if (!estudioTurnosState.estudioTurnos.loading)
      if (
        estudioTurnosState.estudioTurnos.data !== undefined &&
        estudioTurnosState.estudioTurnos.data !== null &&
        estudioTurnosState.estudioTurnos.data !== false &&
        estudioTurnosState.estudioTurnos.data !== ""
      ) {
        if (
          estudioTurnosState.estudioTurnos.data.preparacion !== null ||
          estudioTurnosState.estudioTurnos.data.requiereAutorizacion
        ) {
          if (estudioTurnosState.estudioTurnos.data.preparacion !== "") {
            if (estudioTurnosState.estudioTurnos.data.preparacion) {
              showModal(
                "Turnos/Preparaciones/Preparaciones",
                {
                  titulo:
                    estudioTurnosState.estudioTurnos.data.preparacion ===
                      null ||
                    estudioTurnosState.estudioTurnos.data.preparacion === ""
                      ? "Requiere Autorización"
                      : "Preparaciones",
                  preparacion:
                    estudioTurnosState.estudioTurnos.data.preparacion,
                  autorizacion:
                    estudioTurnosState.estudioTurnos.data.requiereAutorizacion,
                  dissmiss: dissmissPreparacion,
                },
                {},
                "centro",
                true
              )(modalDispatch);
            }
          } else {
            dissmissPreparacion();
          }
        }
      }
    // eslint-disable-next-line
  }, [estudioTurnosState.estudioTurnos.data]);

  useEffect(() => {
    if (estudioTurnosState.estudioTurnos.data) {
      if (
        estudioTurnosState.estudioTurnos.data.continua &&
        estudioTurnosState.estudioTurnos.data.circuito === "KIN" &&
        flgPrepaKin
      ) {
        estudioTurnosState.estudioTurnos.data = null;
        showModalKinesio();
        logoutEstudiosTurnos()(estudioTurnosDispatch);
      }
    }
    // eslint-disable-next-line
  }, [flgPrepaKin]);

  useEffect(() => {
    if (
      estudioTurnosState.estudioTurnos.data !== undefined &&
      estudioTurnosState.estudioTurnos.data !== null &&
      estudioTurnosState.estudioTurnos.data !== false &&
      estudioTurnosState.estudioTurnos.data !== ""
    ) {
      if (estudioTurnosState.estudioTurnos.data.calcularMinutos === true) {
        setFlgCalculaMins(true);
      } else if (
        estudioTurnosState.estudioTurnos.data.calcularMinutos === false
      ) {
        setFlgCalculaMins(false);
      }
      if (
        estudioTurnosState.estudioTurnos.data.continua &&
        estudioTurnosState.estudioTurnos.data.calcularMinutos === false
      ) {
        let particular = false;
        if (flgParticular) {
          particular = true;
        }
        //agregue los cambios de fecha si es anterior a buscar un turno.
        let fecha = fechaDeHoy;
        if (onChangeDate !== null) {
          fecha = onChangeDate;
        } else if (
          turnosDisponiblesState.turnosDisponibles.turnosData.fechaSeleccionada
        ) {
          fecha =
            turnosDisponiblesState.turnosDisponibles.turnosData
              .fechaSeleccionada;
        }
        let config = localStorage.getItem("config");
        let sectorTurno = JSON.parse(config).sectorTurno;

        setDtoBusqEstudioDefault({
          ...dtoBusqEstudioDefault,
          idGrupoMedico: idEstudio,
          fechaDesde: fecha,
          sectorTurno,
          GruposMedico: [
            {
              Id: idEstudio,
              Descripcion: descEstudio,
              Particular: flgParticular,
            },
          ],
          particular: particular,
          idObraSocial: selectDropDownState.selectDropDown.selectGlobal
            .pacienteElegido
            ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                .paciente.obra_social
            : user.auth.data.paciente.obra_social,
          idPlan: selectDropDownState.selectDropDown.selectGlobal
            .pacienteElegido
            ? selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                .paciente.idplan
            : user.auth.data.paciente.idplan,
        });
        setFlgBusquedaDefault(true);
        //en el siguiente paso deberia preguntar primero por el circuito, y luego el push.
      } else if (
        estudioTurnosState.estudioTurnos.data.turnos !== null &&
        estudioTurnosState.estudioTurnos.data.turnos !== undefined &&
        estudioTurnosState.estudioTurnos.data.turnos !== ""
      ) {
        const grupoMed =
          turnosDisponiblesState.turnosDisponibles.turnosData.GruposMedico;
        let particular = false;
        if (flgParticular) {
          particular = true;
        }
        let config = localStorage.getItem("config");
        let sectorTurno = JSON.parse(config).sectorTurno;
        editaTurnosDisponibles({
          ...turnosDisponiblesState.turnosDisponibles.turnosData,
          turnos: estudioTurnosState.estudioTurnos.data.turnos,
          GruposMedico: dtoPOST.GruposMedico,
          particular: particular,
          idEstudio: Array.isArray(grupoMed) ? grupoMed[0].id : idEstudio,
          descEstudio: Array.isArray(grupoMed)
            ? grupoMed[0].descripcion
            : descEstudio,
          descEspecialidad: null,
          fechaBusqueda: estudioTurnosState.estudioTurnos.data.fechaBusqueda,
          sectorTurno,
          dtoBusqueda: dtoPOST,
          volverOrigen: "ESTUDIOS",
          proceso: "estudios",
          circuito: leyendaCircuito,
        })(turnosDisponiblesDispatch);
        history.push("/turnosDisponibles");
      } else if (
        estudioTurnosState.estudioTurnos.data.continua &&
        estudioTurnosState.estudioTurnos.data.circuito !== ""
      ) {
        const arrDeter = determinaciones.filter(
          (item) =>
            item.idcircuito === estudioTurnosState.estudioTurnos.data.circuito
        );
        setDeterminaciones(arrDeter);
        const arrGrupoMed = gruposMedico.filter(
          (item) => item.id === idEstudio
        );
        if (typeof arrGrupoMed !== "undefined" && arrGrupoMed.length > 0) {
          showToaster(
            {
              texto: "Ya existe el turno agregado!",
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);
          logoutEstudiosTurnos()(estudioTurnosDispatch);
        } else {
          setGruposMedico([
            ...gruposMedico,
            {
              id: idEstudio,
              descripcion: descEstudio,
              diasbusqueda: 0,
              filtroedadmax: 0,
              filtroedadmin: 0,
              idequivcontraste: 0,
              incidenciasmin: 0,
              omitirporminbusq: 0,
              videoatencion: false,
              particular: flgParticular,
            },
          ]);
          logoutEstudiosTurnos()(estudioTurnosDispatch);
        }
      } else if (
        estudioTurnosState.estudioTurnos.data.minutos !== "" &&
        estudioTurnosState.estudioTurnos.data.minutos !== undefined &&
        leyendaCircuito !== ""
      ) {
        // Una vez que estan calculados los minutos procedo a completar el dto
        // para realizar la busqueda de turnos
        completarDtoBusquedaTurnos();
      } else if (
        estudioTurnosState.estudioTurnos.data !== undefined &&
        estudioTurnosState.estudioTurnos.data !== null &&
        estudioTurnosState.estudioTurnos.data !== false &&
        estudioTurnosState.estudioTurnos.data !== "" &&
        Array.isArray(estudioTurnosState.estudioTurnos.data)
      ) {
        let config = localStorage.getItem("config");
        let sectorTurno = JSON.parse(config).sectorTurno;
        editaTurnosDisponibles({
          ...turnosDisponiblesState.turnosDisponibles.turnosData,
          turnos: estudioTurnosState.estudioTurnos.data,
          grupoMedico: null,
          particular: flgParticular,
          idEstudio: idEstudio,
          descEstudio: descEstudio,
          descEspecialidad: null,
          fechaBusqueda: onChangeDate !== null ? onChangeDate : fechaDeHoy,
          dtoBusqueda: { ...dtoPOST, osAlternativa: OSAlternativa },
          sectorTurno,
          volverOrigen: "ESTUDIOS",
          circuito: leyendaCircuito,
        })(turnosDisponiblesDispatch);
        history.push("/turnosDisponiblesKinesiologia");
      } else {
        if (estudioTurnosState.estudioTurnos.data.codigo !== 0) {
          if (estudioTurnosState.estudioTurnos.data.codigo === 9) {
            setFlgParticular(true);
            setFlgModal(true);
            modalParticular();
            logoutEstudiosTurnos()(estudioTurnosDispatch);
          } else if (estudioTurnosState.estudioTurnos.data.codigo === 10) {
            modalAtencionSinTurnoPrevio();
            logoutEstudiosTurnos()(estudioTurnosDispatch);
          } else if (estudioTurnosState.estudioTurnos.data.codigo === 91) {
            setFlgParticular(false);
            setFlgModal(true);
            modalOSAlternativa();
            logoutEstudiosTurnos()(estudioTurnosDispatch);
          } else if (estudioTurnosState.estudioTurnos.data.codigo) {
            if (estudioTurnosState.estudioTurnos.data.mensaje.length > 100) {
              showModal(
                "Genericos/Mensaje/Mensaje",
                {
                  titulo: <p className="rb18b">Información</p>,
                  textoNegrita: (
                    <p
                      className="rb18l"
                      dangerouslySetInnerHTML={{
                        __html: estudioTurnosState.estudioTurnos.data.mensaje,
                      }}
                    ></p>
                  ),
                  danger: true,
                  dissmiss: dissmiss,
                },
                [
                  {
                    text: "Aceptar",
                    clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
                    accion: dissmiss,
                  },
                ],
                "centro",
                true
              )(modalDispatch);
            } else {
              showToaster(
                {
                  texto: estudioTurnosState.estudioTurnos.data.mensaje,
                  tipo: "danger",
                },
                "centroArriba"
              )(toasterDispatch);
            }
            logoutEstudiosTurnos()(estudioTurnosDispatch);
          }
        } else {
          showToaster(
            {
              texto: "No se hizo la consulta",
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);
          logoutEstudiosTurnos()(estudioTurnosDispatch);
        }
      }
    } else if (estudioTurnosState.estudioTurnos.circuitoReso.flgForm) {
      // dirijo luego de esto a un nuevo useEffect donde hago la consulta.
      dissmiss();
      setPreguntasReso(estudioTurnosState.estudioTurnos.circuitoReso);
      if (flgCalculaMins) {
        setDtoCalculaMinutos({
          ConContraste: estudioTurnosState.estudioTurnos.circuitoReso.contraste,
          GruposMedico: gruposMedico,
          idObraSocial: user.auth.data.paciente.obra_social,
          idPlan: user.auth.data.paciente.idplan,
        });
      } else {
        completarDtoBusquedaTurnos();
      }
      logoutEstudiosTurnos()(estudioTurnosDispatch);
    } else if (estudioTurnosState.estudioTurnos.circuitoTomo.flgForm) {
      // dirijo luego de esto a un nuevo useEffect donde hago la consulta.
      dissmiss();
      setPreguntasTomo(estudioTurnosState.estudioTurnos.circuitoTomo);
      if (flgCalculaMins) {
        setDtoCalculaMinutos({
          ConContraste:
            estudioTurnosState.estudioTurnos.circuitoTomo.conContraste,
          GruposMedico: gruposMedico,
          idObraSocial: user.auth.data.paciente.obra_social,
          idPlan: user.auth.data.paciente.idplan,
        });
      } else {
        completarDtoBusquedaTurnos();
      }
      logoutEstudiosTurnos()(estudioTurnosDispatch);
    } else if (activarBusqueda) {
      // dirijo luego de esto a un nuevo useEffect donde hago la consulta.
      dissmiss();
      if (flgCalculaMins) {
        setDtoCalculaMinutos({
          ConContraste: false,
          GruposMedico: gruposMedico,
          idObraSocial: user.auth.data.paciente.obra_social,
          idPlan: user.auth.data.paciente.idplan,
        });
      } else {
        completarDtoBusquedaTurnos();
      }
      // logoutEstudiosTurnos()(estudioTurnosDispatch);
      setActivarBusqueda(false);
    } else if (
      estudioTurnosState.estudioTurnos.error?.detail !== "" &&
      estudioTurnosState.estudioTurnos.error?.detail !== null &&
      estudioTurnosState.estudioTurnos.error?.detail !== undefined
    ) {
      if (
        estudioTurnosState.estudioTurnos.error.detail !== "" &&
        estudioTurnosState.estudioTurnos.error.detail !== null &&
        estudioTurnosState.estudioTurnos.error.detail !== undefined
      ) {
        if (estudioTurnosState.estudioTurnos.error.detail.length > 100) {
          showModal(
            "Genericos/Mensaje/Mensaje",
            {
              titulo: "Atención",
              texto: (
                <div
                  dangerouslySetInnerHTML={{
                    __html: estudioTurnosState.estudioTurnos.error.detail,
                  }}
                ></div>
              ),
              dissmiss: dissmiss,
              danger: true,
            },
            [
              {
                text: "Volver",
                clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
                accion: cancelaParticular,
              },
            ],
            "centro"
          )(modalDispatch);
        } else {
          if (estudioTurnosState.estudioTurnos.error.detail?.length > 100) {
            showModal(
              "Genericos/Mensaje/Mensaje",
              {
                titulo: <p className="rb18b">Información</p>,
                textoNegrita: (
                  <p
                    className="rb18l"
                    dangerouslySetInnerHTML={{
                      __html: estudioTurnosState.estudioTurnos.error.detail,
                    }}
                  ></p>
                ),
                danger: true,
                dissmiss: dissmiss,
              },
              [
                {
                  text: "Aceptar",
                  clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
                  accion: dissmiss,
                },
              ],
              "centro",
              true
            )(modalDispatch);
          } else {
            showToaster(
              {
                texto: (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: estudioTurnosState.estudioTurnos.error.detail,
                    }}
                  ></div>
                ),
                tipo: "danger",
              },
              "centroArriba"
            )(toasterDispatch);
          }
        }
        if (gruposMedico.length > 0) {
          setIdEstudio(gruposMedico[0].id);
          setDescEstudio(gruposMedico[0].descripcion);
        }
        logoutEstudiosTurnos()(estudioTurnosDispatch);
      } else {
        if (estudioTurnosState?.estudioTurnos?.error?.length > 100) {
          showModal(
            "Genericos/Mensaje/Mensaje",
            {
              titulo: <p className="rb18b">Información</p>,
              textoNegrita: (
                <p
                  className="rb18l"
                  dangerouslySetInnerHTML={{
                    __html: estudioTurnosState.estudioTurnos.error,
                  }}
                ></p>
              ),
              danger: true,
              dissmiss: dissmiss,
            },
            [
              {
                text: "Aceptar",
                clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
                accion: dissmiss,
              },
            ],
            "centro",
            true
          )(modalDispatch);
        } else {
          showToaster(
            {
              texto: estudioTurnosState.estudioTurnos.error,
              tipo: "danger",
            },
            "centroArriba"
          )(toasterDispatch);
        }
        logoutEstudiosTurnos()(estudioTurnosDispatch);
      }
    }
  }, [estudioTurnosState, activarBusqueda]);

  const completarDtoBusquedaTurnos = () => {
    const grupoMed = estudioTurnosState.estudioTurnos.data
      ? estudioTurnosState.estudioTurnos.data.data
      : gruposMedico;

    let config = localStorage.getItem("config");
    let sectorTurno = JSON.parse(config).sectorTurno;
    if (leyendaCircuito === "RMN") {
      setDtoBusqEstudioCReso({
        circuito: leyendaCircuito,
        amamantando: false,
        conContraste: preguntasReso.contraste, ////lo obtengo de seleccionar el item especialidad o estudio
        contrasteReciente: false,
        diabeticoHipertenso: false,
        embarazada: false,
        fechaDesde: onChangeDate !== null ? onChangeDate : fechaDeHoy, //fecha esta en datepicker
        GruposMedico: grupoMed,
        idGrupoMedico: grupoMed[0].id, //lo obtengo de seleccionar el item especialidad o estudio
        idObraSocial: user.auth.data.paciente.obra_social, //lo obtengo del usuario
        idPlan: user.auth.data.paciente.idplan, // y aca
        insRenal: preguntasReso.renal,
        marcapasos: preguntasReso.marcaPasos,
        operador: accion ? "BOT" : "",
        minutosGrupo: estudioTurnosState.estudioTurnos.data
          ? estudioTurnosState.estudioTurnos.data.minutos
          : 0,
        pag: 1200, //hardcodeado en angular
        particular: grupoMed[0].particular,
        peso: preguntasReso.peso,
        rec: 0, //harcodeado en angularionic
        sectorTurno,
        tipoiva: user.auth.data.paciente.iva,
        videoAtencion: onChangeVc, //lo lleno por con el checkbox
        bioseguridadDTO: {
          flgConContraste: preguntasReso.contraste,
          flgDiabetico: false,
          flgHipertenso: false,
          flgInsuficienciaRenal: preguntasReso.renal,
          flgLabFuncionRenal: preguntasReso.labFuncionRenal,
          flgMarcapasos: preguntasReso.marcaPasos,
          flgImplanteMetalico: preguntasReso.flgImplanteMetalico,
          materialImpMet: preguntasReso.materialImpMet,
          ubicacionImpMet: preguntasReso.ubicacionImpMet,
          fechaImpMet:
            preguntasReso.fechaImpMet === ""
              ? "01-01-0001"
              : preguntasReso.fechaImpMet,
          marcaMarcapasos: preguntasReso.marcaMarcapasos,
          modeloMarcapasos: preguntasReso.modeloMarcapasos,
          fechaMarcapasos:
            preguntasReso.fechaMarcapasos === ""
              ? "01-01-0001"
              : preguntasReso.fechaMarcapasos,
        },
      });
    } else if (leyendaCircuito === "TOMO") {
      setDtoBusqEstudioCTomo({
        circuito: leyendaCircuito,
        amamantando: preguntasTomo.amamantando,
        conContraste: preguntasTomo.contraste, ////lo obtengo de seleccionar el item especialidad o estudio
        contrasteReciente: preguntasTomo.contrasteReciente,
        diabeticoHipertenso: preguntasTomo.diabeticoHipertenso,
        embarazada: preguntasTomo.embarazo,
        fechaDesde: onChangeDate !== null ? onChangeDate : fechaDeHoy, //fecha esta en datepicker
        GruposMedico: grupoMed,
        idGrupoMedico: grupoMed[0].id, //lo obtengo de seleccionar el item especialidad o estudio
        idObraSocial: user.auth.data.paciente.obra_social,
        idPlan: user.auth.data.paciente.idplan,
        insRenal: preguntasTomo.renal,
        marcapasos: false,
        operador: accion ? "BOT" : "",
        minutosGrupo: estudioTurnosState.estudioTurnos.data
          ? estudioTurnosState.estudioTurnos.data.minutos
          : 0,
        pag: 1200, //hardcodeado en angular
        particular: grupoMed[0].particular,
        peso: preguntasTomo.peso,
        rec: 0, //harcodeado en angularionic
        sectorTurno,
        tipoiva: user.auth.data.paciente.iva,
        videoAtencion: onChangeVc, //lo lleno por con el checkbox
        bioseguridadDTO: {
          flgConContraste: preguntasTomo.contraste,
          flgDiabetico: preguntasTomo.flgDiabetico,
          flgHipertenso: preguntasTomo.flgHipertenso,
          flgInsuficienciaRenal: preguntasTomo.renal,
          flgLabFuncionRenal: preguntasTomo.labFuncionRenal,
          flgMarcapasos: false,
          flgImplanteMetalico: false,
          materialImpMet: "",
          ubicacionImpMet: "",
          fechaImpMet: "0001-01-01",
          marcaMarcapasos: "",
          modeloMarcapasos: "",
          fechaMarcapasos: "0001-01-01",
        },
      });
    } else {
      setDtoBusqEstudioCircuito({
        amamantando: false,
        conContraste: false, ////lo obtengo de seleccionar el item especialidad o estudio
        contrasteReciente: false,
        diabeticoHipertenso: false,
        embarazada: false,
        fechaDesde: onChangeDate !== null ? onChangeDate : fechaDeHoy, //fecha esta en datepicker
        GruposMedico: grupoMed,
        idGrupoMedico: grupoMed[0].id, //lo obtengo de seleccionar el item especialidad o estudio
        idObraSocial: user.auth.data.paciente.obra_social, //lo obtengo del usuario
        idPlan: user.auth.data.paciente.idplan, // y aca
        insRenal: false,
        marcapasos: false,
        operador: accion ? "BOT" : "",
        minutosGrupo: estudioTurnosState.estudioTurnos.data
          ? estudioTurnosState.estudioTurnos.data.minutos
          : 0,
        pag: 1200, //hardcodeado en angular
        particular: grupoMed[0].particular,
        peso: false,
        rec: 0, //harcodeado en angularionic
        sectorTurno,
        tipoiva: user.auth.data.paciente.iva,
        videoAtencion: onChangeVc, //lo lleno por con el checkbox
      });
    }
    editaTurnosDisponibles({
      ...turnosDisponiblesState.turnosDisponibles.turnosData,
      GruposMedico: grupoMed,
      idEstudio: grupoMed[0].id,
      descEstudio: grupoMed[0].descripcion,
    })(turnosDisponiblesDispatch);
    logoutEstudiosTurnos()(estudioTurnosDispatch);
  };

  useEffect(() => {
    if (dtoCalculaMinutos !== undefined) {
      wsPostCalulaMinutos(dtoCalculaMinutos)(estudioTurnosDispatch);
      setDtoCalculaMinutos(undefined);
    }
  }, [dtoCalculaMinutos]);

  useEffect(() => {
    if (
      dtoBusqEstudioCReso !== undefined ||
      dtoBusqEstudioCTomo !== undefined ||
      dtoBusqEstudioCircuito !== undefined
    ) {
      let dtoBusq = dtoBusqEstudioCReso
        ? dtoBusqEstudioCReso
        : dtoBusqEstudioCTomo
        ? dtoBusqEstudioCTomo
        : dtoBusqEstudioCircuito;

      setDtoPOST(dtoBusq);
      wsPostTurnosEstudiosQr(dtoBusq)(estudioTurnosDispatch);
      setDtoBusqEstudioCReso(undefined);
    }
  }, [dtoBusqEstudioCReso, dtoBusqEstudioCTomo, dtoBusqEstudioCircuito]);

  //agrego logica volver a verificar estudio por cambio de paciente.
  useEffect(() => {
    if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
      // deberia preguntar primero si busque algo. aca usamos idestudio.
      if (leyendaCircuito !== "" && gruposMedico.length >= 1) {
        setLeyendaCircuito("");
        setGruposMedico([]);
        setIdEstudio("");
        setDescEstudio("");
        const arrGrupoMed = estudioGrupoState.estudioGrupo.data.filter(
          (item) => item.sonpracticas === true && item.id > 0
        );
        setDeterminaciones(arrGrupoMed);
      } else {
        if (idEstudio !== "") {
          wsGetVerificaEstudiosQr(
            idEstudio,
            false,
            false
          )(estudioTurnosDispatch);
        }
      }
    } else {
      // deberia preguntar primero si busque algo. aca usamos idestudio.
      // aca vuelvo a revisar por el usuario que se logueo.
      // deberia preguntar primero si busque algo. aca usamos idestudio.
      if (leyendaCircuito !== "" && gruposMedico.length >= 1) {
        setLeyendaCircuito("");
        setGruposMedico([]);
        setIdEstudio("");
        setDescEstudio("");
        const arrGrupoMed = estudioGrupoState.estudioGrupo.data.filter(
          (item) => item.sonpracticas === true && item.id > 0
        );
        setDeterminaciones(arrGrupoMed);
      } else {
        if (idEstudio !== "") {
          wsGetVerificaEstudiosQr(
            idEstudio,
            false,
            false
          )(estudioTurnosDispatch);
        }
      }
    }
  }, [selectDropDownState.selectDropDown.selectGlobal]);

  useEffect(() => {
    if (estudioGrupoState.estudioGrupo.data !== null) {
      const arrGrupoMed = estudioGrupoState.estudioGrupo.data.filter(
        (item) => item.sonpracticas === true && item.id > 0
      );
      let filtCantidad = arrGrupoMed.sort((a, b) => {
        return b.cantBusquedas - a.cantBusquedas;
      });
      setDeterminaciones(filtCantidad);
      setFechaDeHoy(fechaTurnoFormat());
    }
    //agregue este reset para tener siempre los filtros a cero
    resetFiltrosDisponibles()(turnosDisponiblesDispatch);
  }, []);

  // Busca el dia de hoy para el datePicker
  const hoyDia = new Date();
  const noventaDiasDespues = new Date();
  noventaDiasDespues.setDate(noventaDiasDespues.getDate() + 90);

  const modalTurnosPresentismo = () => {
    // if (selectDropDownState.selectDropDown.selectGlobal.pacienteElegido) {
    //   wsGetPresentismoDetalle(
    //     false,
    //     selectDropDownState.selectDropDown.selectGlobal.pacienteElegido.id
    //   )(presentismoDispatch);
    // } else {
    //   wsGetPresentismoDetalle(false, false)(presentismoDispatch);
    // }
  };

  // useEffect(() => {
  //   if (presentismoState.presentismo.data !== null) {
  //     showModal(
  //       "Turnos/ModalPresentismo/ModalPresentismo",
  //       {
  //         dissmiss: dissmiss,
  //         danger: true,
  //       },
  //       [],
  //       "centro",
  //       true
  //     )(modalDispatch);
  //   }
  // }, [presentismoState.presentismo.data]);

  // const modalInfoPresentismo = () => {
  //   showModal(
  //     "Genericos/Mensaje/Mensaje",
  //     {
  //       titulo: <p className="rb24b">Información</p>,
  //       textoNegrita: (
  //         <p
  //           className="rb18l explicacionPresentismoEstudios"
  //           dangerouslySetInnerHTML={{
  //             __html:
  //               textosState?.textos?.data?.msjPresentismoAyuda?.descripcion,
  //           }}
  //         ></p>
  //       ),
  //       dissmiss: dissmiss,
  //     },
  //     [
  //       {
  //         text: "Aceptar",
  //         clase: "btn-Mensaje b-latex30 c-latex30 rb16m",
  //         accion: dissmiss,
  //       },
  //     ],
  //     "centro",
  //     true
  //   )(modalDispatch);
  // };

  const configDropdown = {
    data: determinaciones,
    autoFocus: true,
    ordenPersonalizado: true,
    header: buscadorTurnos ? "" : "Buscá lo que necesites",
    headerColor: buscadorTurnos && "c-white",
    footer: gruposMedico.length > 0 ? "" : "Buscá un estudio o análisis",
    descripcion: "descripcion",
    placeholder: textosState.textos.data?.txtEstudios?.descripcion,
    placeHolderFontSize: 16,
    defaultValue: "tags",
    defaultValueParametro: "id",
    height: 38,
    cantidadItems: 10,
    maxlength: 100,
    error: errorDropdown,
    arrow: true,
    search: false,
    disabled: false,
    tooltip: false,
    showUp: true,
    regex: /^[a-zA-Z\s]+$/,
    masBuscados: true,
    buscarPorDefault: true,
  };

  useEffect(() => {
    if (ordenDigitalState.ordenDigital.grupoMed !== null) {
      const sinDuplicados = ordenDigitalState.ordenDigital.grupoMed.filter(
        (item, index, self) => index === self.findIndex((t) => t.id === item.id)
      );
      setOrdenesDigitales(sinDuplicados);
      onChangeBuscador(sinDuplicados[0]);
    }
  }, [ordenDigitalState.ordenDigital.grupoMed]);

  return (
    <React.Fragment>
      {!buscadorTurnos && (
        <>
          <div className="ptur-buscadorEstudio-desktop-dropdown">
            <Dropdown
              valor={
                listaFamiliaresState.listaFamiliares.loading &&
                (listaFamiliaresState.listaFamiliares.data === null ||
                  listaFamiliaresState.listaFamiliares.data === "")
                  ? ""
                  : !selectDropDownState.selectDropDown.selectGlobal
                      .pacienteElegido
                  ? authState.auth.data.paciente.codigo
                  : selectDropDownState.selectDropDown.selectGlobal
                      .pacienteElegido.id
              }
              datos={dropdownFamiliares(
                listaFamiliaresState,
                authState,
                "ManejoTurnos"
              )}
              campoCodigo="id"
              descripcion="nombre"
              onChange={onChangeMultitabMobile}
              placeholder={
                listaFamiliaresState.listaFamiliares.loading &&
                (listaFamiliaresState.listaFamiliares.data === null ||
                  listaFamiliaresState.listaFamiliares.data === "")
                  ? "Cargando Familiares..."
                  : ""
              }
              desactivado={
                listaFamiliaresState.listaFamiliares.loading &&
                (listaFamiliaresState.listaFamiliares.data === null ||
                  listaFamiliaresState.listaFamiliares.data === "")
                  ? true
                  : false
              }
              heightLista={"auto"}
              customCss={"widthDropdownBuscadorEstudios"}
            />
            {/* <PresentismoBox
              consultas={false}
              modalInfoPresentismo={modalInfoPresentismo}
              modalTurnosPresentismo={modalTurnosPresentismo}
            /> */}
          </div>

          {/* <div className="ptur-buscadorEstudio-presentismoMobile">
            <PresentismoBox
              consultas={false}
              modalInfoPresentismo={modalInfoPresentismo}
              modalTurnosPresentismo={modalTurnosPresentismo}
            />
          </div> */}
        </>
      )}

      <div
        className={
          buscadorTurnos
            ? "ptur-cuerpoPestania-estudioBuscadorTurno"
            : "ptur-cuerpoPestania-estudio"
        }
      >
        <div
          className={
            buscadorTurnos
              ? "ptur-buscadorTurnos-dropdown-estudio"
              : "ptur-buscador-dropdown-estudio"
          }
        >
          {Array.isArray(gruposMedico) && gruposMedico.length > 0 && (
            <div className="ptur-estudio-informacionBuscador-desktop">
              <InformacionBuscador
                onClick={showInfoBuscador}
                leyendaCircuito={leyendaCircuito}
              />
            </div>
          )}
          <DropdownV2 config={configDropdown} onClick={onChangeBuscador} />
        </div>
        <div
          className={
            buscadorTurnos
              ? "ptur-buscadorTurnos-fechaBoton-container"
              : "ptur-buscador-fechaBoton-container"
          }
        >
          <div
            className={
              buscadorTurnos
                ? "ptur-buscadorTurno-fecha-estudio"
                : "ptur-buscador-fecha-estudio"
            }
          >
            <DatePicker
              fechaInicial={`${hoyDia.getFullYear()} ${
                hoyDia.getMonth() + 1
              } ${hoyDia.getDate()}`}
              fechaFinal={`${noventaDiasDespues.getFullYear()} ${
                noventaDiasDespues.getMonth() + 1
              } ${noventaDiasDespues.getDate()}`}
              headerStr={"Buscar fecha"}
              headerStrColor={buscadorTurnos && "c-white"}
              // fechaMin={hoy}
              onChange={onChangeDatePicker}
              customCss={
                buscadorTurnos
                  ? "ptur-datePickerBuscadorTurnos-estudios"
                  : "ptur-datePicker-estudios"
              }
            />
          </div>
          <div
            className={
              buscadorTurnos
                ? "ptur-buscadorTurnos-boton-estudio"
                : "ptur-buscador-boton-estudio"
            }
          >
            <button
              onClick={onBuscarTurnosClick}
              className={`${
                buscadorTurnos
                  ? "ptur-btn-buscadorTurnos-estudio"
                  : "ptur-btn-buscador-estudio"
              } bgc-primary c-white rb18m`}
              disabled={estudioTurnosState.estudioTurnos.loading}
            >
              {estudioTurnosState.estudioTurnos.loading ? (
                <span className="ptur-buscadorEstudio-loading">
                  <IonSpinner name="lines-small" />
                </span>
              ) : (
                "Siguiente"
              )}
            </button>
          </div>
        </div>
      </div>
      {Array.isArray(gruposMedico) && gruposMedico.length > 0 && (
        <>
          <div className="ptur-estudio-informacionBuscador-mobile">
            <InformacionBuscador
              onClick={showInfoBuscador}
              leyendaCircuito={leyendaCircuito}
            />
          </div>
          <TurnosAgregados
            onClickHandlerCancelarEtiq={onClickHandlerCancelarEtiq}
            gruposMedico={gruposMedico}
            buscadorTurnos={buscadorTurnos}
          />
        </>
      )}
    </React.Fragment>
  );
};

export default BuscadorEstudio;
